import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

/**
 * Customer Slice
 * Manages customer-specific state (bookings, services, etc.)
 */
const initialState = {
  bookings: [],
  currentBooking: null,
  services: [],
  loading: false,
  error: null,
};

// Async thunks would go here
// export const fetchBookings = createAsyncThunk(...)

const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    setBookings: (state, action) => {
      state.bookings = action.payload;
    },
    setCurrentBooking: (state, action) => {
      state.currentBooking = action.payload;
    },
    addBooking: (state, action) => {
      state.bookings.unshift(action.payload);
    },
    updateBooking: (state, action) => {
      const index = state.bookings.findIndex((b) => b.id === action.payload.id);
      if (index !== -1) {
        state.bookings[index] = { ...state.bookings[index], ...action.payload };
      }
    },
    setServices: (state, action) => {
      state.services = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setBookings,
  setCurrentBooking,
  addBooking,
  updateBooking,
  setServices,
  setLoading,
  setError,
  clearError,
} = customerSlice.actions;

export default customerSlice.reducer;


